import script from "./downloadApp.vue?vue&type=script&name=downloadApp&setup=true&lang=js"
export * from "./downloadApp.vue?vue&type=script&name=downloadApp&setup=true&lang=js"

import "./downloadApp.vue?vue&type=style&index=0&id=0cc1b36d&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc1b36d"]])

export default __exports__